export default __webpack_public_path__ + "static/media/HIW-wr-2.05d04a05.webp";